import BarChart from "../../BarChart/BarChart";
import React, {useEffect, useState} from "react";
import {apolloClientReports} from "../../../GraphQL/config";
import {QUERY_GET_WATER_CONSUMPTION} from "../../../GraphQL/ReportGenerator/queries";
import {
    buildCategoriesData,
    buildCategoriesDataHighResolution,
    getCategoriesByResolution,
    getEndDate,
    getResolutionName,
    gqlDateFormat,
    pushCsvDates,
    setCsvHeaders,
    sortResponseData
} from "../Utils/utils";
import {EXCEL_TITLE_WATER_CONSUMPTION, WATER_CONSUMPTION_NAME} from "../../../Constants/constants";
import {ProjectColors} from "../../../Enums/Core/projectColors";
import {Spinner} from "react-bootstrap";
import ExportToExcelButton from "../ExportToExcelButton/ExportToExcelButton";
import convert, {DEFAULT_VOLUME_UNIT} from "../MeasurementText/MeasurementTextConverter";

export default function WaterConsumptionHighResolution(props) {
    const [chartData, setChartData] = useState();
    const [categories, setCategories] = useState();
    const [csvData, setCsvData] = useState([]);
    const [volumeUnit, setVolumeUnit] = useState(DEFAULT_VOLUME_UNIT);

    const getWaterConsumptionDataFromDB = async () => {
        if (props.selectedDate && props.modalResulotion) {
            await apolloClientReports.query({
                query: QUERY_GET_WATER_CONSUMPTION, variables: {
                    resolution: getResolutionName(props?.modalResulotion - 1),
                    from: gqlDateFormat(props?.selectedDate),
                    to: gqlDateFormat(getEndDate(props?.selectedDate, props?.modalResulotion - 1))
                }
            }).then(res => {
                let response = res?.data?.waterConsumptionHistogram;
                if (!response) {
                    console.error(`Data from WaterConsumptionData is empty`);
                } else {
                    setVolumeUnit(convert(response.measureUnit.volumeUnit));
                    delete response.data['__typename'];
                    let responseData = sortResponseData(response?.data);
                    setChartData([{
                        name: WATER_CONSUMPTION_NAME,
                        data: response.data.map((res) => res.value),
                        color: ProjectColors.Aqua,
                        showInLegend: false
                    }]);
                    setCategories(buildCategoriesData(responseData, props.modalResulotion - 1));
                    setCsvData(buildCsvData(responseData));
                }
            })
        }
    }

    useEffect(async () => {
        if (props.modalResulotion && props.selectedDate) await getWaterConsumptionDataFromDB();
    }, [props]);


    const buildCsvData = (responseData) => {
        let csvData = [];
        let headers = setCsvHeaders(props.modalResulotion - 1);
        headers.push('Water consumption (L)');
        csvData.push(headers);

        responseData.forEach((entity, index) => {
            let row = [];
            row.push(index + 1);
            row = pushCsvDates(props.modalResulotion - 1, entity.date, row);
            row.push(entity.value);
            csvData.push(row);
        });

        return csvData;
    }

    return (<>
        {!chartData && <Spinner animation="border" variant="primary"/>}
        {chartData && <>
            <div className="float-right">
                <ExportToExcelButton
                    csvData={csvData || null}
                    title={EXCEL_TITLE_WATER_CONSUMPTION}/>
            </div>
            <br/>
            <br/>
            <BarChart
                volumeUnit={volumeUnit}
                categories={categories}
                data={chartData}
            />
        </>}
    </>)
}